// extracted by mini-css-extract-plugin
module.exports = {"root":"LARDB_root__1SxYx"};